<template>
    <div>
        <div class="card-body">
            <table class="table" v-loading="$parentInfo.studentWallet.dialog_ClassHourRetired.loading">
                <thead>
                <tr>
                    <th>学期</th>
                    <th>年级</th>
                    <th>剩余课次</th>
                    <th>需退课次</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in orderStudentClassHours" :key="item.id">
                    <td>{{item.semester_name}}</td>
                    <td>{{item.grade_name}}</td>
                    <td>{{item.has_period}}</td>
                    <td><el-input v-model="item.refund_period" style="width:60px" type="mini"></el-input></td>
                    <td>
                        <el-button type="primary" :disabled="item.has_period<=0"
                                   @click="handleCancelClassHour(item)"
                                   :loading="$parentInfo.studentWallet.dialog_LessonRetired.button_loading">退费
                        </el-button>
                        <el-button type="primary" :disabled="item.has_period<=0"
                                   @click="handleChangeClassHourMsg(item)"
                                   :loading="$parentInfo.studentWallet.dialog_LessonRetired.button_loading">换课次
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <el-dialog
                title="修改课次"
                :visible.sync="$parentInfo.studentWallet.dialog_ClassHourChange.dialogVisible"
                width="400px"
                height="400px"
                :before-close="handleClose"
                append-to-body>
            <div>
                <el-form label-position="left" label-width="100px">
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-form-item label="更换课次数">
                                <el-input v-model="filter.refund_period" size="small" :disabled=true style="width: 200px;"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-form-item label="提升年级">
                                <el-checkbox v-model="filter.next_grade" @change="handleNextSemesters">备选项</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-form-item label="选择学期">
                                <el-select v-model="filter.new_semester_id"
                                           placeholder="请选择学期"
                                           remote
                                           clearable
                                           style="width:200px">
                                    <el-option
                                            v-for="item in $parentInfo.studentWallet.dialog_ClassHourChange.next_semesters"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item>
                        <el-button type="primary" @click="handleChangeClassHour">修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_LessonRetired',
        data() {
            return {
                filter:{
                    refund_period:0,
                    next_grade:false,
                    new_semester_id:'',
                    semester_id:'',
                    grade_id:''
                }
            };
        },
        computed: {
            orderStudentClassHours: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.dialog_ClassHourRetired.studentClassHours, 'id', 'desc');
            },
        },
        mounted() {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentWallet.dialog_ClassHourRetired.loading = true;
            this.handleGetClassHour();
        },
        methods: {
            // 查找相同课程下班级信息
            handleGetClassHour() {
                this.$wApi.send(this.$parentInfo.path, 'get_classHour_in_wallet', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleCancelClassHour(item) {
                this.$parentInfo.studentWallet.dialog_LessonRetired.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'cancel_studentClassHour', {
                    'semester_id': item.semester_id,
                    'grade_id': item.grade_id,
                    'use_period': item.refund_period,
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleChangeClassHourMsg(item){
                this.filter.refund_period=item.refund_period
                this.filter.semester_id=item.semester_id
                this.filter.grade_id=item.grade_id
                this.$parentInfo.studentWallet.dialog_ClassHourChange.dialogVisible=true
                this.handleNextSemesters();
            },
            handleChangeClassHour(){
                this.$wApi.send(this.$parentInfo.path, 'change_studentClassHour', {
                    'semester_id': this.filter.semester_id,
                    'grade_id': this.filter.grade_id,
                    'use_period': this.filter.refund_period,
                    'student_id': this.$parentInfo.student_id,
                    'next_grade':this.filter.next_grade,
                    'new_semester_id':this.filter.new_semester_id,
                });
            },
            handleNextSemesters(){
                this.$wApi.send(this.$parentInfo.path, 'get_next_semesters', {
                    'semester_id': this.filter.semester_id,
                    'next_grade':this.filter.next_grade,
                });
            },
            handleClose(done) {
                done();
            }
        }
    };
</script>

<style scoped>

</style>
